@import (reference) '../../../../../app-brand/entities/entity-layer.module.less';

.legend-label {
  color: @insights-page--label--text-color;
}

.yAxis-label {
  font-size: 24px;
  text-anchor: middle;
}
